import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
var _DarkTheme5_;
import { createTheme, markThemeVersion } from "../../../lib/theming/ThemeHelpers";
import { BasicThemeClassForExtension } from "../BasicTheme";
import { DarkTheme5_2 } from "../DarkTheme5_2";
export var DarkTheme5_3 = createTheme({
  themeClass: (_DarkTheme5_ = /*#__PURE__*/function (_BasicThemeClassForEx) {
    function DarkTheme5_3() {
      return _BasicThemeClassForEx.apply(this, arguments) || this;
    }
    _inheritsLoose(DarkTheme5_3, _BasicThemeClassForEx);
    return DarkTheme5_3;
  }(BasicThemeClassForExtension), _DarkTheme5_.miniModalDescriptionFontSize = '16px', _DarkTheme5_.miniModalDescriptionLineHeight = '22px', _DarkTheme5_),
  prototypeTheme: DarkTheme5_2,
  themeMarkers: [markThemeVersion('5.3')]
});